import { IcCloseCircleFill } from '@kep/kcds-icons';

import { textInputEndAdornmentIconClasses } from './theme';

import type { TextInputProps } from './types';

type TextInputClearIconProps = Pick<TextInputProps, 'onClear' | 'disabledClearable' | 'value'>;

const TextInputClearIcon = (props: TextInputClearIconProps) => {
  const { onClear, disabledClearable, value } = props;

  if (!onClear || disabledClearable || !value) return null;

  return (
    <IcCloseCircleFill
      className={textInputEndAdornmentIconClasses.clearIcon}
      onMouseDown={onClear}
    />
  );
};

export default TextInputClearIcon;
